import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminDashboardProvider } from "./context/AdminDashboardContext";
import ConnectionStatus from "./components/ConnectionStatus";
import SearchResults from "./pages/SearchResults";
import HomePage from "./pages/Home";
import CarDetails from "./pages/CarDetails";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerDashboard from "./pages/PartnerDashboard";
import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeeAuthTest from "./pages/EmployeeAuthTest";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import HandoverForm from "./pages/HandoverForm";
import HandoverDetails from "./pages/HandoverDetails";
import HandoverRedirect from "./pages/HandoverRedirect";
import TransferPage from "./pages/TransferPage";
import DriverDashboard from "./pages/DriverDashboard";
import DriverLogin from "./pages/DriverLogin";
import VehicleServiceReport from "./pages/VehicleServiceReport";
import ErrorPage from "./pages/ErrorPage";

const App = () => {
  return (
    <BrowserRouter>
      <ConnectionStatus />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/car-details/:slug" element={<CarDetails />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboardProvider><AdminDashboard /></AdminDashboardProvider>} />{" "}        <Route
          path="/vehicle-service-report"
          element={<VehicleServiceReport />}
        />
        <Route path="/partner/login" element={<PartnerLogin />} />{" "}
        <Route path="/partner/dashboard" element={<PartnerDashboard />} />
        <Route path="/employee/login" element={<EmployeeLogin />} />
        <Route path="/employee/auth-test" element={<EmployeeAuthTest />} />        
        <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
        <Route
          path="/employee/handovers/new"
          element={<HandoverForm />}
        />
        <Route
          path="/employee/handovers/:handoverId"
          element={<HandoverRedirect />}
        />
        <Route path="/driver/login" element={<DriverLogin />} />
        <Route path="/driver/dashboard" element={<DriverDashboard />} />
        <Route path="/transfers" element={<TransferPage />} />
        <Route path="*" element={<ErrorPage statusCode={404} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
